<script setup lang="ts">
  defineSlots<{
    default(): any,
    title(): any,
  }>();

  defineProps({
    title: { type: String, required: false },
  });
</script>
<template>
  <section class="description-section">
    <header class="description-section__header">
      <slot name="title">
        <SfHeading class="description-section__heading" v-text="title" />
      </slot>
    </header>
    <div class="description-section__content">
      <slot name="default" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
  .description-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media(max-width: 992px) {
      gap: 0.75rem;
    }
  }
</style>